import { theme } from "antd";
import { themeTypes } from "helpers/consts";

const colorPrimary = "#143960";
const colorPrimaryDark = "#386a9f";

const components = {
    Layout: {
        headerHeight: 60,
        headerPadding: 0,
        headerBg: "#0e2740"
    },
    Menu: {
        darkItemBg: "transparent",
        darkItemSelectedBg: "rgba(255, 255, 255, 0.1)",
        horizontalItemBorderRadius: 5,
        itemBg: "transparent",
        horizontalItemSelectedColor: "#fff",
        horizontalItemHoverColor: "#fff",
        activeBarHeight: 3
    }
};

export const themes = {
    light: {
        name: themeTypes.LIGHT,
        algorithm: theme.defaultAlgorithm,
        token: {
            colorPrimary,
            colorBgLayout: "#14396010",
            colorFillQuaternary: "#1439600d",
            colorFillAlter: "#1439600d",
            colorFillTertiary: "#1439600d",
            colorFillSecondary: "#14396012"
        },
        components: {
            ...components,
            Table: {
                borderColor: "#14396012"
            }
        }
    },
    dark: {
        name: themeTypes.DARK,
        algorithm: theme.darkAlgorithm,
        token: {
            colorPrimary: colorPrimaryDark
        },
        components: {
            ...components,
            Tree: {
                nodeSelectedBg: colorPrimaryDark
            },
            Layout: {
                ...components.Layout,
                headerBg: "#141414"
            }
        }
    }
};
